/**
 * Static-translations for nl. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const nl = {
  'anon.description_default': 'Gastsessie wordt ingesteld…',
  'anon.heading_default': 'Doorgaan als gast',
  'anon.try_again': 'Probeer opnieuw',
  'auth.back_to_login': 'Terug naar inloggen',
  'auth.check_email_message': 'Controleer je e-mail voor de bevestigingscode.',
  'auth.check_email_title': 'Controleer je e-mail',
  'auth.confirm_email_subtitle': 'Voer de code in die we naar je e-mail hebben gestuurd om je account aan te maken.',
  'auth.confirm_email_title': 'Bevestig je e-mail',
  'auth.confirmation_code': 'Bevestigingscode',
  'auth.continue_with_apple': 'Doorgaan met Apple',
  'auth.continue_with_facebook': 'Doorgaan met Facebook',
  'auth.continue_with_github': 'Doorgaan met GitHub',
  'auth.continue_with_google': 'Doorgaan met Google',
  'auth.create_account': 'Account aanmaken',
  'auth.default_subtitle': 'Log in om toegang te krijgen tot alle functies en je gegevens te synchroniseren.',
  'auth.email': 'E-mailadres',
  'auth.email_already_registered': 'Dit e-mailadres is al geregistreerd. Log hieronder in met je wachtwoord of het account waarmee je je hebt geregistreerd.',
  'auth.email_exists': 'Er bestaat al een account met dit e-mailadres.',
  'auth.email_not_confirmed': 'Bevestig eerst je e-mailadres.',
  'auth.forgot_password': 'Wachtwoord vergeten?',
  'auth.forgot_password_title': 'Wachtwoord vergeten?',
  'auth.forgot_subtitle': 'Voer je e-mailadres in en we sturen je een link om je wachtwoord opnieuw in te stellen.',
  'auth.generic_error': 'Er ging iets mis',
  'auth.have_account': 'Heb je al een account?',
  'auth.hide_password': 'Wachtwoord verbergen',
  'auth.identity_already_linked': 'Dit account is al geregistreerd. Log er hieronder mee in.',
  'auth.invalid_credentials': 'Ongeldige e-mail of wachtwoord',
  'auth.invalid_otp': 'De code is ongeldig of verlopen.',
  'auth.last_used': 'Laatst gebruikt · {email}',
  'auth.last_used_no_email': 'Laatst gebruikt',
  'auth.link_purchase_subheading': 'We koppelen de aankoop aan je account om toegang te behouden.',
  'auth.log_in': 'Inloggen',
  'auth.log_in_link': 'Inloggen',
  'auth.login_continue_purchase': 'Log in om je aankoop voort te zetten',
  'auth.network_error': 'Netwerkfout. Controleer je verbinding en probeer opnieuw.',
  'auth.new_password_optional': 'Nieuw wachtwoord (optioneel — alleen voor wachtwoordreset)',
  'auth.no_account': 'Nog geen account?',
  'auth.or': 'of',
  'auth.password': 'Wachtwoord',
  'auth.passwords_mismatch': 'Wachtwoorden komen niet overeen',
  'auth.rate_limited': 'Te veel verzoeken. Probeer het later opnieuw.',
  'auth.repeat_password': 'Herhaal wachtwoord',
  'auth.reset_link_valid': 'De link is 1 uur geldig.',
  'auth.reset_password_subtitle': 'Voer de code uit je e-mail en een nieuw wachtwoord in.',
  'auth.reset_password_title': 'Wachtwoord opnieuw instellen',
  'auth.reset_sent_message': 'Als dat e-mailadres bestaat, is er een resetcode verzonden.',
  'auth.reset_sent_subtitle': 'We hebben een wachtwoord-resetlink verzonden. Volg de instructies in de e-mail.',
  'auth.restore_purchases_heading': 'Aankopen Herstellen',
  'auth.restore_purchases_subheading': 'Log in om je aankopen te herstellen.',
  'auth.send_reset': 'Reset-e-mail Versturen',
  'auth.service_unavailable': 'Service tijdelijk niet beschikbaar. Probeer het later opnieuw.',
  'auth.show_password': 'Wachtwoord tonen',
  'auth.sign_out': 'Uitloggen',
  'auth.sign_up': 'Registreren',
  'auth.sign_up_link': 'Registreren',
  'auth.signed_in': 'Ingelogd',
  'auth.signin_failed': 'Inloggen mislukt',
  'auth.signup_failed': 'Registratie mislukt',
  'auth.verify': 'Verifiëren',
  'auth.weak_password': 'Het wachtwoord is te zwak.',
  'auth.welcome': 'Welkom!',
  'auth.welcome_signup': 'Welkom!',
  'cta.close': 'Sluiten',
  'cta.continue': 'Doorgaan',
  'cta.get_lifetime_access': 'Levenslange toegang',
  'cta.get_plan_daily': 'Dagelijks plan',
  'cta.get_plan_generic': 'Plan {interval}',
  'cta.get_plan_monthly': 'Maandelijks plan',
  'cta.get_plan_weekly': 'Wekelijks plan',
  'cta.get_plan_yearly': 'Jaarlijks plan',
  'cta.start_trial': 'Start {days} Dagen Gratis Proefperiode',
  'modal.close_aria': 'Sluiten',
  'modal.continue': 'Doorgaan',
  'modal.error_generic': 'Er ging iets mis',
  'modal.loading': 'Laden…',
  'modal.purchase_restored_subtitle': 'Alles is klaar — veel plezier!',
  'modal.purchase_restored_title': 'Welkom terug',
  'modal.purchase_success_subtitle': 'Alles is klaar — veel plezier!',
  'modal.purchase_success_title': 'Betaling ontvangen',
  'modal.verifying_subscription': 'Abonnement controleren…',
  'nav.back': '← Terug',
  'nav.back_aria': 'Terug',
  'offer.limited_time': 'Tijdelijke aanbieding',
  'payment.awaiting_subtitle': 'We detecteren je betaling automatisch — of klik hieronder zodra je klaar bent.',
  'payment.awaiting_title': 'Voltooi de betaling in het nieuwe tabblad',
  'payment.checking': 'Controleren…',
  'payment.ive_paid': 'Ik heb betaald',
  'payment.open_checkout_again': 'Checkout opnieuw openen',
  'payment.open_checkout_button': 'Checkout openen',
  'payment.popup_blocked_message': 'Je browser blokkeerde het checkouttabblad. Klik hieronder om het te openen.',
  'payment.popup_blocked_title': 'Sta pop-ups toe om door te gaan',
  'payment.popup_help_text': 'Het checkoutvenster ging niet open of werd geblokkeerd? Klik hier om het opnieuw te openen.',
  'payment.still_processing': 'De betaling wordt nog verwerkt. Probeer het zo opnieuw.',
  'payment.tab_closed_retry': 'Tabblad gesloten? Probeer opnieuw',
  'pricing.free_trial_days': '{days} dagen gratis proefperiode',
  'pricing.included_per': 'Inbegrepen per {interval}:',
  'pricing.interval.day': 'dag',
  'pricing.interval.lifetime_short': 'voor altijd',
  'pricing.interval.month': 'maand',
  'pricing.interval.period': 'periode',
  'pricing.interval.week': 'week',
  'pricing.interval.year': 'jaar',
  'pricing.money_back': '30 dagen geld-terug-garantie',
  'pricing.most_popular': 'Populairst',
  'pricing.no_prices': 'Geen prijzen beschikbaar.',
  'pricing.plan_label.daily': 'DAGELIJKS PLAN',
  'pricing.plan_label.lifetime': 'levenslang',
  'pricing.plan_label.monthly': 'maandelijks abonnement',
  'pricing.plan_label.weekly': 'wekelijks abonnement',
  'pricing.plan_label.yearly': 'jaarlijks abonnement',
  'pricing.plans_aria': 'Plannen',
  'session.contact_support': 'Contact met support',
  'session.restore_purchases': 'Aankopen herstellen',
  'session.sign_out': 'Uitloggen',
  'session.signed_in_as_prefix': 'Ingelogd als',
  'session.signing_out': 'Uitloggen…',
  'support.attachments_aria': 'Bijlagen uploaden',
  'support.attachments_label': 'Bijlagen',
  'support.close_button': 'Sluiten',
  'support.done_button': 'Klaar',
  'support.dropzone_text': 'Sleep afbeeldingen hierheen of klik om te selecteren',
  'support.email_placeholder': 'Voer je e-mailadres in',
  'support.file_requirements': 'JPEG/PNG/WebP, tot {max} bestanden, ≤ {size} MB elk',
  'support.heading': 'Ondersteuning',
  'support.instruction': 'Vul het onderstaande formulier in om je ondersteuningsverzoek te verzenden.',
  'support.invalid_email': 'Ongeldig e-mailadres',
  'support.invalid_file': 'Alleen JPEG/PNG/WebP, ≤ {size} MB elk',
  'support.message_length': '1–5000 tekens',
  'support.message_placeholder': 'Voer je bericht in',
  'support.remove_file_aria': '{filename} verwijderen',
  'support.required': 'Verplicht',
  'support.send_another': 'Nog een verzoek versturen',
  'support.send_button': 'Versturen',
  'support.sending': 'Verzenden…',
  'support.sending_as': 'Verzenden als',
  'support.subject_length': '3–200 tekens',
  'support.subject_placeholder': 'Voer je onderwerp in',
  'support.success_heading': 'Verzoek verzonden',
  'support.success_message_prefix': 'We hebben je bericht ontvangen en zullen reageren op',
  'support.too_many_files': 'Tot {max} bestanden'
} as const;

export default nl;
